import React from 'react';
import { gikClassPrefix } from '@gik/core/constants';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import classnames from 'classnames';

export const hintBlockName = `${gikClassPrefix}-hint`;

export default function Hint({ children, className = '' }: PropsWithClassName<React.PropsWithChildren<{}>>) {
  const classNames = classnames([hintBlockName, className]);

  return <span className={classNames}>{children}</span>;
}
